<div class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-flex-xxxxl-row">
    <div
        class="cmps-cdk-flex-100 cmps-cdk-flex-xl-65 cmps-cdk-flex-xxxxl-50 cmps-cdk-pr-xl-1dot5"
    >
        <cmps-stacked-card-next>
            <cmps-card-next
                [collapsable]="true"
                #userSearchCard
            >
                <cmps-card-header-next>
                    {{ _i18n._657_SELECT_A_USER | translate }}
                </cmps-card-header-next>
                <cmps-card-body-next>
                    <div
                        searchuser
                        [userId]="state?.selectedUser?.value?.id"
                        (select)="_onUserSelect($event)"
                        #userSearch
                        *ngIf="!state?.pending?.reload"
                    ></div>

                    <cmps-radio-group
                        class="cmps-cdk-mt-2"
                        [ngModel]="state?.selectedSearchType?.value"
                        (ngModelChange)="_searchType = $event"
                    >
                        <cmps-radio
                            class="cmps-cdk-mr-1"
                            [value]="_SearchType.INDIVIDUAL"
                            >{{
                                _i18n._1502_INDIVIDUAL | translate
                            }}</cmps-radio
                        >
                        <cmps-radio
                            class="cmps-cdk-mr-1"
                            [value]="_SearchType.TEAM"
                            >{{ _i18n._7471_TEAM | translate }}</cmps-radio
                        >
                        <cmps-radio
                            class="cmps-cdk-mr-1"
                            [value]="_SearchType.TEAM_AND_SUBORDINATES"
                            >{{
                                _i18n._1504_TEAM___SUBORDINATES | translate
                            }}</cmps-radio
                        >
                    </cmps-radio-group>
                </cmps-card-body-next>
            </cmps-card-next>

            <cmps-card-next [hidden]="userSearchCard?.collapsed">
                <cmps-card-header-next>
                    {{ _i18n._10014_SELECT_DATE_RANGE | translate }}
                </cmps-card-header-next>
                <cmps-card-body-next>
                    <div class="cmps-cdk-d-flex">
                        <div class="cmps-cdk-flex-50 cmps-cdk-pr-1dot5">
                            <div>{{ _i18n._9684_FROM | translate }}</div>
                            <div class="cmps-form-input-group">
                                <input
                                    class="cmps-form-input"
                                    cmpsDateTimePicker
                                    [onlyDate]="true"
                                    [ngModel]="
                                        state?.selectedDateRange?.value?.start
                                    "
                                    (ngModelChange)="_dateRangeStart = $event"
                                    #dpStart="cmpsDateTimePicker"
                                />
                                <button
                                    class="cmps-icon-button--no-bg cmps-form-input-group--icon"
                                    cmpsIconButton
                                    [attr.aria-expanded]="dpStart.isOpen()"
                                    (click)="dpStart.toggle()"
                                >
                                    <cmps-icon
                                        svgIcon="calendar-range"
                                    ></cmps-icon>
                                </button>
                            </div>
                        </div>
                        <div class="cmps-cdk-flex-50">
                            <div>{{ _i18n._9685__TO | translate }}</div>
                            <div class="cmps-form-input-group">
                                <input
                                    class="cmps-form-input"
                                    cmpsDateTimePicker
                                    [onlyDate]="true"
                                    [ngModel]="
                                        state?.selectedDateRange?.value?.end
                                    "
                                    (ngModelChange)="_dateRangeEnd = $event"
                                    #dpEnd="cmpsDateTimePicker"
                                />
                                <button
                                    class="cmps-icon-button--no-bg cmps-form-input-group--icon"
                                    cmpsIconButton
                                    [attr.aria-expanded]="dpEnd.isOpen()"
                                    (click)="dpEnd.toggle()"
                                >
                                    <cmps-icon
                                        svgIcon="calendar-range"
                                    ></cmps-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="cmps-eval-search--search-btn">
                        <button
                            cmpsButton
                            (click)="_onSearchClick()"
                        >
                            <span cmpsButtonLabel>{{
                                _i18n._710_SEARCH | translate
                            }}</span>
                        </button>
                    </div>
                </cmps-card-body-next>
            </cmps-card-next>
        </cmps-stacked-card-next>
    </div>

    <div
        class="cmps-cdk-flex-100 cmps-cdk-flex-xxxxl-50 cmps-cdk-mt-1dot5 cmps-cdk-mt-xxxxl-0"
        *ngIf="state?.rows != null"
    >
        <cmps-card-next
            [collapsable]="true"
            #searchResultsCard
        >
            <cmps-card-header-next>
                {{ _i18n._97_SEARCH_RESULTS | translate }}
            </cmps-card-header-next>
            <cmps-card-body-next>
                <div
                    ngGrid
                    class="cmps-eval-search-table"
                    [rendererOptions]="_tableData?.rendererOpts"
                    [selectTemplate]="_tableData?.selectTpl"
                    [rows]="_tableData?.rows"
                    [sortDefs]="_tableData?.sortDefs"
                    [dataRows]="state?.rows"
                    [filteredDataRows]="state?.filteredRows"
                    *ngIf="state?.rows?.length > 0"
                >
                    <ng-template
                        gridContent
                        data-type="grid"
                    >
                        <div></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="row"
                        data-id="header"
                    >
                        <div class="cmps-eval-search-table--row-header"></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="cell"
                        data-id="header"
                        let-c="c"
                        let-ctx="ctx"
                    >
                        <div>
                            <div
                                [ngClass]="
                                    'cmps-eval-search-table--row-header--' +
                                    ctx?.data?.classSuffix
                                "
                            >
                                <button
                                    class="cmps-eval-search-table--row-header--button"
                                    (click)="_onColumnSortClick(c)"
                                    *ngIf="c.id !== _ColumnId.SELECT"
                                >
                                    <span
                                        class="cmps-eval-search-table--row--text"
                                        >{{
                                            ctx?.data?.label | translate
                                        }}</span
                                    >
                                    <cmps-icon
                                        [svgIcon]="
                                            state?.sortOptions?.order ===
                                            _SortOrder.ASC
                                                ? 'chevron-up'
                                                : 'chevron-down'
                                        "
                                        [hidden]="
                                            state?.sortOptions?.columnId !==
                                            c?.id
                                        "
                                    ></cmps-icon>
                                </button>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="row"
                        data-id="content"
                    >
                        <div class="cmps-eval-search-table--row"></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="cell"
                        data-id="content"
                        let-c="c"
                        let-ctx="ctx"
                    >
                        <div [ngSwitch]="c.id">
                            <div
                                class="cmps-eval-search-table--row--user-name"
                                *ngSwitchCase="_ColumnId.USER_NAME"
                            >
                                <span
                                    class="cmps-eval-search-table--row--text"
                                    >{{
                                        ctx?.data?.targetUserName ?? '-'
                                    }}</span
                                >
                            </div>
                            <div
                                class="cmps-eval-search-table--row--event-date"
                                *ngSwitchCase="_ColumnId.EVENT_DATE"
                            >
                                <span class="cmps-eval-search-table--row--text">
                                    {{
                                        (ctx?.data?.eventDate
                                            | cmpsDate: 'yyyy-MM-dd') ?? '-'
                                    }}
                                </span>
                            </div>
                            <div
                                class="cmps-eval-search-table--row--evaluation-date"
                                *ngSwitchCase="_ColumnId.EVALUATION_DATE"
                            >
                                <span class="cmps-eval-search-table--row--text">
                                    {{
                                        (ctx?.data?.evaluationDate
                                            | cmpsDate: 'yyyy-MM-dd') ?? '-'
                                    }}
                                </span>
                            </div>
                            <div
                                class="cmps-eval-search-table--row--score"
                                *ngSwitchCase="_ColumnId.SCORE"
                            >
                                <span class="cmps-eval-search-table--row--text">
                                    {{
                                        (ctx?.data?.percentage
                                            | cmpsPercent: '1.2-2') ?? '-'
                                    }}
                                </span>
                            </div>
                            <div
                                class="cmps-eval-search-table--row--evaluation-name"
                                *ngSwitchCase="_ColumnId.EVALUATION_NAME"
                            >
                                <span
                                    class="cmps-eval-search-table--row--text"
                                    >{{ ctx?.data?.evaluationName }}</span
                                >
                            </div>
                            <div
                                class="cmps-eval-search-table--row--status"
                                *ngSwitchCase="_ColumnId.STATUS"
                            >
                                <span class="cmps-eval-search-table--row--text">
                                    {{
                                        (ctx?.data?.draftId != null
                                            ? _i18n._9476_DRAFT
                                            : _i18n._9113_PUBLISHED
                                        ) | translate
                                    }}
                                </span>
                            </div>
                            <div
                                class="cmps-eval-search-table--row--select"
                                *ngSwitchCase="_ColumnId.SELECT"
                            >
                                <button
                                    class="cmps-outline-button--sm cmps-outline-button--outline"
                                    cmpsOutlineButton
                                    (click)="_onSelectRowClick(ctx?.data)"
                                >
                                    <span cmpsOutlineButtonLabel>{{
                                        _i18n._99_SELECT | translate
                                    }}</span>
                                </button>
                            </div>
                        </div>
                    </ng-template>
                </div>

                <div
                    class="cmps-cdk-text-center"
                    *ngIf="state?.rows?.length === 0"
                >
                    {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
                </div>

                <div
                    class="cmps-cdk-text-center cmps-cdk-mt-1dot5"
                    *ngIf="state?.canLoadMore"
                >
                    <button
                        cmpsButton
                        (click)="_onLoadMoreClick()"
                    >
                        <cmps-icon svgIcon="plus"></cmps-icon>
                        <span cmpsButtonLabel>{{
                            _i18n._10015_LOAD_MORE | translate
                        }}</span>
                    </button>
                </div>
            </cmps-card-body-next>
        </cmps-card-next>
    </div>
</div>

<router-outlet></router-outlet>
